export function strTrim(v) {
  if (v == null) return '';
  return String(v).trim();
}

export function hasDefeitoAlert(ordem) {
  return strTrim(ordem.defeito_alert).length > 0;
}

export function normalizeHexColor(input) {
  if (input == null) return null;
  let s = String(input).trim();
  if (!s) return null;
  if (!s.startsWith('#')) s = `#${s}`;
  if (/^#[0-9a-fA-F]{3}$/i.test(s)) {
    s = `#${s[1]}${s[1]}${s[2]}${s[2]}${s[3]}${s[3]}`;
  }
  if (!/^#[0-9a-fA-F]{6}$/i.test(s)) return null;
  return s;
}

export function defeitoAlertTooltipText(ordem) {
  const parts = [];
  const desc = strTrim(ordem.defeito_descricao);
  if (desc) parts.push(desc);
  const al = strTrim(ordem.defeito_alert);
  if (al) parts.push(`Alerta: ${al}`);
  const cl = strTrim(ordem.defeito_classification);
  if (cl) parts.push(`Classificação: ${cl}`);
  const sev = strTrim(ordem.defeito_severity_level);
  if (sev) parts.push(`Severidade: ${sev}`);
  return parts.length ? parts.join('\n') : al || 'Defeito';
}
